import Companies from "./views/Companies.vue";

export default [
  {
    path: "/empresas",
    component: Companies,
    name: "empresas",
    meta: { isAuthenticated: true },
  },
];



// WEBPACK FOOTER //
// ./src/components/empresas/routes.js